import { fetchClient } from '@/util/fetchClient';

/**
 * Why a URL is wanted, which decides what the server reports. `render` draws a
 * file in a thread and reports nothing, `view` is a photo opened in a preview,
 * and `download` is a file saved or opened.
 */
export type DownloadUrlPurpose = 'render' | 'view' | 'download';

export async function createDownloadUrlV2(key: string, purpose: DownloadUrlPurpose = 'download') {
  const { data } = await fetchClient.POST('/v2/attachments/download-url', {
    body: {
      s3Key: key,
      purpose,
    },
  });

  return data?.data;
}
